var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFourWeekPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#d6ecf0",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M46.12,45.29h18.63c1.3,0,2.37-1.06,2.37-2.37s-1.06-2.37-2.37-2.37h-18.63c-1.3,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M46.12,59.08h34.76c1.3,0,2.37-1.06,2.37-2.37s-1.06-2.37-2.37-2.37h-34.76c-1.3,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M46.12,72.87h34.76c1.3,0,2.37-1.06,2.37-2.37s-1.06-2.37-2.37-2.37h-34.76c-1.3,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M46.12,86.66h34.76c1.3,0,2.37-1.06,2.37-2.37s-1.06-2.37-2.37-2.37h-34.76c-1.3,0-2.37,1.06-2.37,2.37s1.06,2.37,2.37,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32a1b3",
    d: "M94.27,41.03l-15.68-16.13c-.55-.57-1.28-.88-2.08-.88h-34.29c-5.69,0-10.31,4.63-10.31,10.32v58.53c0,5.69,4.63,10.32,10.31,10.32h42.55c5.69,0,10.31-4.63,10.31-10.32v-49.82c0-.76-.29-1.48-.82-2.02ZM79.41,40.15v-6.08l5.9,6.08h-5.9ZM37.71,34.34c0-2.49,2.02-4.52,4.51-4.52h31.38v13.22c0,1.6,1.3,2.9,2.9,2.9h12.77v46.92c0,2.49-2.02,4.52-4.51,4.52h-42.55c-2.49,0-4.51-2.03-4.51-4.52v-58.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourWeekPlans);
export default __webpack_public_path__ + "static/media/four-week-plans.139f80d72f077368cae5dd59553fa856.svg";
export { ForwardRef as ReactComponent };